import { ListToVirtualizedList } from './ListToVirtualizedList.component';

export default ListToVirtualizedList;
